import React,
{
  useEffect,
  useState
} from "react";

import axios from "axios";

const BASE_API =
  process.env.BASE_API_URL ||
  "https://scanmymenu-nm38.onrender.com/api";

export default function AdminDashboard() {

  const [restaurants, setRestaurants] =
    useState([]);

  const [search, setSearch] =
    useState("");

  const [page, setPage] =
    useState(1);

  const itemsPerPage = 6;

  
  const [loading, setLoading] =
    useState(true);

  /*
  LOGOUT
  */

  const logout = () => {

    localStorage.removeItem(
      "adminToken"
    );

    localStorage.removeItem(
      "userRole"
    );

    window.location.href =
      "/admin-login";

  };

  /*
  NAVIGATION
  */

  const createRestaurant = () => {

    window.location.href =
      "/create-restaurant";

  };

  const viewOwners = () => {

    window.location.href =
      "/owners";

  };

  const editRestaurant =
    (id) => {

    window.location.href =
      `/edit-restaurant/${id}`;

  };

  /*
  FETCH RESTAURANTS
  */

  useEffect(() => {

    fetchRestaurants();

  }, []);

  const fetchRestaurants =
    async () => {

    try {

      const res =
        await axios.get(
          `${BASE_API}/restaurants`
        );

      setRestaurants(res.data);

    } catch (error) {

      console.log(
        "Failed to fetch restaurants"
      );

    } finally {

      setLoading(false);

    }

  };

  /*
  DELETE
  */

  const deleteRestaurant =
    async (id) => {

    if (
      !window.confirm(
        "Delete restaurant?"
      )
    )
      return;

    try {

      await axios.delete(
        `${BASE_API}/restaurants/${id}`
      );

      fetchRestaurants();

    } catch (error) {

      alert(
        "Delete failed"
      );

    }

  };

  /*
  FILTER + PAGINATION
  */

  const filtered =
    restaurants.filter(
      (r) =>
        r.restaurantName
          ?.toLowerCase()
          .includes(
            search.toLowerCase()
          )
    );

  const start =
    (page - 1) *
    itemsPerPage;

  const paginated =
    filtered.slice(
      start,
      start + itemsPerPage
    );

  const totalPages =
    Math.ceil(
      filtered.length /
        itemsPerPage
    );

return (

  <div style={styles.container}>

    <h1>
      Admin Dashboard
    </h1>

    {/* TOP ACTIONS */}

    <div style={styles.actions}>

      <button
        onClick={createRestaurant}
        style={styles.createBtn}
      >
        Create Restaurant
      </button>

      <button
        onClick={viewOwners}
        style={styles.ownerBtn}
      >
        Owner List
      </button>

      <button
        onClick={logout}
        style={styles.logoutBtn}
      >
        Logout
      </button>

    </div>

    {/* SEARCH */}

    <input
      type="text"
      placeholder="Search restaurant..."
      value={search}
      onChange={(e) =>
        setSearch(
          e.target.value
        )
      }
      style={styles.search}
    />

    {/* LIST */}

    {loading ? (

      <p>Loading...</p>

    ) : (

      <div style={styles.grid}>

        {paginated.map(
          (restaurant) => (
            
            <div
              key={restaurant.id}
              style={styles.card}
              onClick={() =>
                window.location.href = `/restaurant/${restaurant.id}`
              }
            >
              {/* LOGO */}

              {restaurant.logoUrl && (

                <img
                  src={`${restaurant.logoUrl}`}
                  alt="logo"
                  style={styles.logo}
                />

              )}

              {/* NAME */}

              <h3>
                {
                  restaurant.restaurantName
                }
              </h3>

              {/* ADDRESS */}

              <p>
                {
                  restaurant.restaurantAddress
                }
              </p>

              {/* SUBSCRIPTION STATUS */}

              <p>

                Status:

                <span
                  style={{
                    marginLeft: "8px",
                    fontWeight: "bold",
                    color:
                      restaurant.subscriptionStatus === "active"
                        ? "green"
                        : "red"
                  }}
                >

                  {
                    restaurant.subscriptionStatus
                  }

                </span>

              </p>

              {/* ACTION BUTTONS */}

              <div
                style={
                  styles.cardButtons
                }
              >

                <button
                  style={
                    styles.editBtn
                  }
                  onClick={() =>
                    editRestaurant(
                      restaurant.id
                    )
                  }
                >
                  Edit
                </button>

                <button
                  style={
                    styles.deleteBtn
                  }
                  onClick={() =>
                    deleteRestaurant(
                      restaurant.id
                    )
                  }
                >
                  Delete
                </button>

              </div>

            </div>

          )
        )}

      </div>

    )}

    {/* PAGINATION */}

    <div style={styles.pagination}>

      <button
        disabled={page === 1}
        onClick={() =>
          setPage(
            page - 1
          )
        }
      >
        Prev
      </button>

      <span>
        Page {page} / {totalPages}
      </span>

      <button
        disabled={
          page === totalPages
        }
        onClick={() =>
          setPage(
            page + 1
          )
        }
      >
        Next
      </button>

    </div>

  </div>

);

}

const styles = {

  container: {
    padding: "24px",
    minHeight: "100vh",
    background: "#f4f6fb",
    fontFamily: "Segoe UI, sans-serif"
  },

  /* TOP ACTIONS */

  actions: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginBottom: "20px"
  },

  createBtn: {
    padding: "12px 16px",

    background:
      "linear-gradient(90deg,#1e3c72,#2a5298)",

    color: "#fff",

    border: "none",

    borderRadius: "10px",

    fontWeight: "600",

    cursor: "pointer",

    boxShadow:
      "0 4px 12px rgba(30,60,114,0.4)"
  },

  ownerBtn: {
    padding: "12px 16px",

    background:
      "linear-gradient(90deg,#2563eb,#1d4ed8)",

    color: "#fff",

    border: "none",

    borderRadius: "10px",

    fontWeight: "600",

    cursor: "pointer"
  },

  logoutBtn: {
    padding: "12px 16px",

    background:
      "linear-gradient(90deg,#dc2626,#b91c1c)",

    color: "#fff",

    border: "none",

    borderRadius: "10px",

    fontWeight: "600",

    cursor: "pointer"
  },

  /* SEARCH */

  search: {
    width: "100%",
    maxWidth: "350px",

    padding: "12px 14px",

    borderRadius: "10px",

    border: "1px solid #ddd",

    fontSize: "15px",

    marginBottom: "22px",

    outline: "none",

    background: "#fff",

    boxShadow:
      "0 2px 6px rgba(0,0,0,0.05)"
  },

  /* GRID */

  grid: {
    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fill, minmax(260px, 1fr))",

    gap: "20px"
  },

  /* CARD */

  card: {
    background: "#ffffff",

    padding: "20px",

    borderRadius: "14px",

    boxShadow:
      "0 6px 14px rgba(0,0,0,0.08)",

    transition: "0.2s"
  },

  /* LOGO */

  logo: {
    width: "80px",
    height: "80px",

    objectFit: "cover",

    borderRadius: "12px",

    marginBottom: "12px",

    border: "1px solid #eee"
  },

  /* CARD BUTTONS */

  cardButtons: {
    marginTop: "15px",

    display: "flex",

    gap: "10px"
  },

  editBtn: {
    flex: 1,

    padding: "9px",

    background:
      "linear-gradient(90deg,#2563eb,#1d4ed8)",

    color: "#fff",

    border: "none",

    borderRadius: "8px",

    cursor: "pointer",

    fontWeight: "600"
  },

  deleteBtn: {
    flex: 1,

    padding: "9px",

    background:
      "linear-gradient(90deg,#dc2626,#b91c1c)",

    color: "#fff",

    border: "none",

    borderRadius: "8px",

    cursor: "pointer",

    fontWeight: "600"
  },

  /* PAGINATION */

  pagination: {
    marginTop: "28px",

    display: "flex",

    justifyContent: "center",

    alignItems: "center",

    gap: "14px"
  }

};